import React from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../components/common/breadcrumb.component";
import "./applicationGenerator.css";
import Generator from "./generator";

const ApplicationGenerator = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <Breadcrumb
        title={t("profile.applicationGenerator.title")}
        parent={t("profile.title")}
      />
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <div className="table-responsive">
              <Generator />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ApplicationGenerator);
